/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import Facebook from '../assets/facebook.png';
import Twitter from '../assets/twitter.png';
import Instagram from '../assets/instagram.png';
import LinkedIn from '../assets/linkedin.png';
import Youtube from '../assets/youtube.png';
import SunWestDarkTheme from '../assets/SunWestDarkTheme.png';
import LocationIcon from '../assets/location.png';
import PhoneIcon from '../assets/telephone.png';
import EmailIcon from '../assets/email.png';
import Logo2 from '../assets/2.png';
import Logo3 from '../assets/3.png';
import Logo4 from '../assets/4.png';
import Logo5 from '../assets/5.png';
import Logo6 from '../assets/6.png';
import Logo7 from '../assets/7.png';
import Logo8 from '../assets/8.png';
import Logo9 from '../assets/9.png';
import BestInBusiness from '../assets/best_in_business_logo_3.png';
import ImpactConnect from '../assets/impact_connect (1).png';
import FooterStyles from '../css/Footer.module.css';
import { NavLink } from 'react-router-dom';

function Footer() {
  return (
    <footer className={FooterStyles.footer}>
      {/* Logo and copyright notices */}
      <img src={SunWestDarkTheme} className={FooterStyles.logo} alt='SunWest Mortgage Company, Inc. NMLS 3277' />
      <p className={FooterStyles.footerParagraph}>
        For licensing information, go to:{' '}
        <a href='https://www.nmlsconsumeraccess.org/' style={{ color: '#FFFFFF' }}>
          www.nmlsconsumeraccess.org
        </a>
        . Visit{' '}
        <a href='https://www.swmc.com/disclaimer' style={{ color: '#FFFFFF' }}>
          https://www.swmc.com/disclaimer
        </a>{' '}
        for the full list of license information.
        <br /><br />
        Please{' '}
        <a href='https://www.swmc.com/txdis' style={{ color: '#FFFFFF' }}>
          Click Here
        </a>{' '}
        to view Texas Complaint Notice and Servicing Disclosure.
      </p>

      {/* Horizontal Separator */}
      <hr className={FooterStyles.sectionSeparator} />

      {/* Contact Us Section */}
      <h2 className={FooterStyles.connectText}>Contact Us</h2>
      <div className={FooterStyles.contactInfo}>
        <div className={FooterStyles.contactRow}>
          <img src={LocationIcon} alt='Location' className={FooterStyles.contactIcon} />
          <span>18303 Gridley Road, Cerritos, CA 90703</span>
        </div>
        <div className={FooterStyles.contactRow}>
          <img src={PhoneIcon} alt='Phone' className={FooterStyles.contactIcon} />
          <span>(833) 478-6937</span>
        </div>
        <div className={FooterStyles.contactRow}>
          <img src={EmailIcon} alt='Email' className={FooterStyles.contactIcon} />
          <span>inquiry@swmc.com</span>
        </div>
      </div>

      {/* Horizontal Separator */}
      <hr className={FooterStyles.sectionSeparator} />

      {/* Section 2 - Social Media Logos */}
      <div className={FooterStyles.connectBox}>
        <h2 className={FooterStyles.connectText}>Connect With Us</h2>
        <div className={FooterStyles.connect}>
          <a href='https://x.com/SunWestMortgage?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor' target='_blank' rel='noopener noreferrer' title='Open Twitter in new tab'>
            <img src={Twitter} alt='Twitter' />
          </a>
          <a href='https://www.instagram.com/sunwestmortgage.inc/' target='_blank' rel='noopener noreferrer' title='Open Instagram in new tab'>
            <img src={Instagram} alt='Instagram' />
          </a>
          <a href='https://www.youtube.com/@SunWestMortgage_1980' target='_blank' rel='noopener noreferrer' title='Open in new tab'>
            <img src={Youtube} alt='YouTube' />
          </a>
          <a href='https://www.linkedin.com/company/sun-west-mortgage-company' target='_blank' rel='noopener noreferrer' title='Open LinkedIn in new tab'>
            <img src={LinkedIn} alt='LinkedIn' />
          </a>
          <a href='https://www.facebook.com/SunWestMortgage' target='_blank' rel='noopener noreferrer' title='Open Facebook in new tab'>
            <img src={Facebook} alt='Facebook' />
          </a>
        </div>
      </div>

      {/* Partner/Compliance Logos */}
      <div className={FooterStyles.partnerLogos}>
        <img src={BestInBusiness} alt='Best in Business' className={FooterStyles.fillLogo} />
        <img src={Logo2} alt='Partner 2' className={FooterStyles.croppedLogo} />
        <img src={ImpactConnect} alt='Impact Connect' className={FooterStyles.impactConnect} />
        <img src={Logo3} alt='Partner 3' className={FooterStyles.logo3} />
        <img src={Logo4} alt='Alliance' className={FooterStyles.logo4} />
        <img src={Logo5} alt='Reviews' className={FooterStyles.logo5} />
        <img src={Logo6} alt='Forbes' className={FooterStyles.row2Logo} />
        <img src={Logo7} alt='Equal Housing Opportunity' className={FooterStyles.row2Logo} />
        <img src={Logo8} alt='Partner 8' className={FooterStyles.largeLogo} />
        <img src={Logo9} alt='Partner 9' className={FooterStyles.largeLogo} />
      </div>

      {/* Footer Links */}
      <div className={FooterStyles.footerLinks}>
        <NavLink to='/contact-us'>Contact Us</NavLink>
        <a href='https://angelai.com' target='_blank' rel='noopener noreferrer'>Ask AngelAi</a>
        <NavLink to='/privacy-policy'>Borrower Concerns &amp; Complaints Privacy Policy</NavLink>
        <NavLink to='/e-sign-consent'>E-Sign Consent</NavLink>
        <NavLink to='/terms-and-conditions'>Terms and Conditions</NavLink>
        <NavLink to='/disclaimers'>Licenses</NavLink>
        <NavLink to='/site-map'>Site Map</NavLink>
      </div>

      <p className={FooterStyles.copyright}>&copy; 2026 Sun West Mortgage Company, Inc. All Rights Reserved.</p>

      {/* Horizontal Separator */}
      <hr className={FooterStyles.sectionSeparator} />
    </footer>
  );
}

export default Footer;
